import { conf } from "./conf";
export const fromApiServer = s =>
  s.startsWith("http://") || s.startsWith("https://")
    ? s
    : [conf.apiserver, s].filter(Boolean).join("/");
